import {
  route,
} from '@app/Routing/helpers'
import { accessPermission } from '@access/permissions'

import {
  ALL,
} from '@app/Seller/accessTokens'

const Base = () => import('@app/Seller/Components/Base')
const ShippingList = () => import('@app/Seller/Shipping/List.vue')

const ModulesNewPostView = () => import('@app/Seller/Modules/Novaposhta/View')
const ModulesNovaposhtaList = () => import('@app/Seller/Modules/Novaposhta/List')
const ModulesNovaposhtaSettings = () => import('@app/Seller/Modules/Novaposhta/Settings')
const ModulesNovaposhtaAdd = () => import('@app/Seller/Modules/Novaposhta/Add')

const PickupList = () => import('@app/Seller/Pickup/List')

const MODEL = 'shipping'

const BASE = `${MODEL}/`

const LIST = ''

export const SHIPPING_PREFIX = `${MODEL}:`
const p = name => SHIPPING_PREFIX + name

export const SHIPPING_BASE_NAME = p('base')
export const SHIPPING_LIST_NAME = p('list')

const NOVAPOSHTA_INIT_VIEW = 'novaposhta/'
const NOVAPOSHTA_SETTINGS_VIEW = 'settings/'
const NOVAPOSHTA_LIST_VIEW = 'list/'
const NOVAPOSHTA_ADD_VIEW = 'add/'

const PICKUP_LIST_VIEW = 'pickup/'

export const MODULES_BASE_NAME = p('novaposhta:base')
export const MODULES_NEW_POST_NAME = p('novaposhta:init')
export const MODULES_NEW_POST_SETTINGS_NAME = p('novaposhta:settings')
export const MODULES_NEW_POST_LIST_NAME = p('novaposhta:list')
export const MODULES_NEW_POST_ADD_NAME = p('novaposhta:add')

export const PICKUP_LIST_NAME = p('pickup:list')

export function createRoutes(options) {
  return [
    route(BASE, Base, SHIPPING_BASE_NAME, {
      meta: accessPermission(ALL, options),
      redirect: { name: SHIPPING_LIST_NAME },
      children: [
        route(LIST, ShippingList, SHIPPING_LIST_NAME, {
          meta: accessPermission(ALL, options),
        }),
        route(NOVAPOSHTA_INIT_VIEW, ModulesNewPostView, MODULES_NEW_POST_NAME, {
          meta: {
            ...accessPermission(ALL, options),
          },
          redirect: { name: MODULES_NEW_POST_LIST_NAME },
          children: [
            route(NOVAPOSHTA_LIST_VIEW, ModulesNovaposhtaList, MODULES_NEW_POST_LIST_NAME, {
              meta: {
                ...accessPermission(ALL, options),
              },
            }),
            route(NOVAPOSHTA_SETTINGS_VIEW, ModulesNovaposhtaSettings, MODULES_NEW_POST_SETTINGS_NAME, {
              meta: {
                ...accessPermission(ALL, options),
              },
            }),
            route(NOVAPOSHTA_ADD_VIEW, ModulesNovaposhtaAdd, MODULES_NEW_POST_ADD_NAME, {
              meta: {
                ...accessPermission(ALL, options),
              },
            }),
          ],
        }),
        route(PICKUP_LIST_VIEW, PickupList, PICKUP_LIST_NAME, {
          meta: {
            ...accessPermission(ALL, options),
          },
        }),
      ],
    }),
  ]
}
